import { SeriesId } from '@mui/x-charts/models';
import { useCallback, useMemo, useState } from 'react';

// This hook controls series-level highlights only.
export const useLegendHighlight = () => {
  const [highlightedSeriesId, setHighlightedSeriesId] = useState<SeriesId | null>(null);

  const highlightedItem = useMemo(
    () => (highlightedSeriesId ? { seriesId: highlightedSeriesId } : null),
    [highlightedSeriesId]
  );

  const onHighlightChange = useCallback((item: { seriesId: SeriesId } | null) => {
    setHighlightedSeriesId(item?.seriesId ?? null);
  }, []);

  const onLegendItemHover = useCallback((id: string) => setHighlightedSeriesId(id), []);
  const onLegendItemLeave = useCallback(() => setHighlightedSeriesId(null), []);

  return { highlightedItem, onHighlightChange, onLegendItemHover, onLegendItemLeave };
};
